import React from "react";

const WorkMasterHeader = () => {
  return (
    <div className="mb-4 border-bottom pb-3">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h2 className="mb-2">💼 कार्य मास्टर</h2>
          <p className="text-muted mb-0">कार्य प्रकार और कार्य क्षेत्र का प्रबंधन करें</p>
        </div>
      </div>
    </div>
  );
};

export default WorkMasterHeader;
